import type { EDealType, TPageType } from 'shared/types/features';

export type TStepAccent = 'sale' | 'rent' | 'host';

export const getStepAccent = (pageType: TPageType, dealType?: EDealType | null): TStepAccent | undefined => {
  if (pageType === 'host') {
    return 'host';
  }

  if (pageType === 'sob' && dealType) {
    return dealType;
  }

  return undefined;
};
